import React, { useState } from 'react';
import styles from './spei.module.css';
import Loading from '../../Loading';
import Iconify from '../../Iconify';
import { useOPMTransferClabe } from './use-opm-clabe';
import useUserContext from '../../../hooks/useUserContext';
import { useCopyClipboard } from '../shared/hooks/use-copy-clipboard';

// Assets
import iconoHeader from '../shared/assets/icono-usa-esta-info-para-tu-transf.png';
import iconoTarjeta from '../shared/assets/icono-tarjeta.png';
import iconoBanco from '../shared/assets/icono-banco.png';
import iconoUsuario from '../shared/assets/icono-usuario.png';
import iconoConcepto from '../shared/assets/icono-concepto.png';
import { SpeiWarnings } from '../shared/components/spei-warnings';
import { waitVerificationName } from '../shared/components/modals/modal-verification-name';
import { waitUserCancelCashoutsPending } from '../shared/utils/cashouts';

export const SpeiOPMTransfer = () => {
  // data = {"clabe":"","minAmount":100,"maxAmount":100000}
  const { data, isLoading } = useOPMTransferClabe();
  const { userData } = useUserContext();
  const [step, setStep] = useState('IDLE');

  const { copyToClipboard, copiedField } = useCopyClipboard();

  if (isLoading) {
    return <Loading label="Cargando información..." />;
  }

  // Datos por defecto de la cuenta CLABE Pickwin
  const clabe = data?.clabe ?? 'Error al cargar la cuenta CLABE';
  const banco = 'TRANSFER';
  const beneficiario = userData?.user?.full_name?.toUpperCase() ?? '';
  const concepto = 'DEPOSITO PICKWIN';

  const handleCopy = (text, fieldName) => {
    copyToClipboard(text, fieldName);
  };

  const handleGetInfo = async () => {
   
    // const isVerified = await waitVerificationName({
    //   title: 'Verificación de nombre',
    // });

    // if (!isVerified) {
    //   alert('Por favor, verifica tu cuenta para continuar.');
    //   return;
    // }

    const userCancell = await waitUserCancelCashoutsPending({
      buttonConfirm: 'Obtener información del deposito.',
      buttonCancel: 'Cancelar',
    }); 

    if (userCancell) {
      setIsSubmitting(false);
      return;
    }
 
    setStep('CLABE');
  };

  if (step === 'IDLE') {
    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.headerIcon}>
              <img src={iconoHeader} alt="Icono de información" />
            </div>
            <button className="payment-button" onClick={handleGetInfo} style={{ marginTop: '2em' }}>Obtener información del deposito.</button>
          </div>
          <SpeiWarnings />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {/* Header con icono y título */}
        <div className={styles.header}>
          <div className={styles.headerIcon}>
            <img src={iconoHeader} alt="Icono de información" />
          </div>
          <h2 className={styles.headerTitle}>
            Usa esta información para{' '}
            <span className={styles.headerTitleHighlight}>hacer tu transferencia</span>
          </h2>
        </div>

        {/* Campos de información */}
        <div className={styles.fieldsContainer}>
          {/* Campo CLABE */}
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>Cuenta CLABE</label>
            <div
              className={`${styles.fieldInput} ${
                copiedField === 'clabe' ? styles.fieldInputCopied : ''
              }`}
              onClick={() => handleCopy(clabe, 'clabe')}
            >
              <img src={iconoTarjeta} alt="Icono tarjeta" className={styles.fieldIcon} />
              <span className={styles.fieldValue}>{clabe}</span>
              {copiedField === 'clabe' ? (
                <span className={styles.copiedFeedback}>
                  <Iconify icon="material-symbols:check-circle" className={styles.copiedIcon} />
                  <span className={styles.copiedText}>¡Copiado!</span>
                </span>
              ) : (
                <Iconify icon="material-symbols:content-copy" className={styles.copyIcon} />
              )}
            </div>
          </div>

          {/* Campo Banco */}
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>Banco</label>
            <div
              className={`${styles.fieldInput} ${
                copiedField === 'banco' ? styles.fieldInputCopied : ''
              }`}
              onClick={() => handleCopy(banco, 'banco')}
            >
              <img src={iconoBanco} alt="Icono banco" className={styles.fieldIcon} />
              <span className={styles.fieldValue}>{banco}</span>
              {copiedField === 'banco' ? (
                <span className={styles.copiedFeedback}>
                  <Iconify icon="material-symbols:check-circle" className={styles.copiedIcon} />
                  <span className={styles.copiedText}>¡Copiado!</span>
                </span>
              ) : (
                <Iconify icon="material-symbols:content-copy" className={styles.copyIcon} />
              )}
            </div>
          </div>

          {/* Campo Beneficiario */}
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>Beneficiario</label>
            <div
              className={`${styles.fieldInput} ${
                copiedField === 'beneficiario' ? styles.fieldInputCopied : ''
              }`}
              onClick={() => handleCopy(beneficiario, 'beneficiario')}
            >
              <img src={iconoUsuario} alt="Icono usuario" className={styles.fieldIcon} />
              <span className={styles.fieldValue}>{beneficiario}</span>
              {copiedField === 'beneficiario' ? (
                <span className={styles.copiedFeedback}>
                  <Iconify icon="material-symbols:check-circle" className={styles.copiedIcon} />
                  <span className={styles.copiedText}>¡Copiado!</span>
                </span>
              ) : (
                <Iconify icon="material-symbols:content-copy" className={styles.copyIcon} />
              )}
            </div>
          </div>

          {/* Campo Concepto */}
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>Concepto</label>
            <div
              className={`${styles.fieldInput} ${
                copiedField === 'concepto' ? styles.fieldInputCopied : ''
              }`}
              onClick={() => handleCopy(concepto, 'concepto')}
            >
              <img src={iconoConcepto} alt="Icono concepto" className={styles.fieldIcon} />
              <span className={styles.fieldValue}>{concepto}</span>
              {copiedField === 'concepto' ? (
                <span className={styles.copiedFeedback}>
                  <Iconify icon="material-symbols:check-circle" className={styles.copiedIcon} />
                  <span className={styles.copiedText}>¡Copiado!</span>
                </span>
              ) : (
                <Iconify icon="material-symbols:content-copy" className={styles.copyIcon} />
              )}
            </div>
          </div>
        </div>

        <SpeiWarnings />
      </div>
    </div>
  );
};
